module.exports = __webpack_public_path__ + "media/burial-document_800.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/burial-document_800.jpg
// module id = 16
// module chunks = 0